window.cartUpsellRecommendations = function (productId) {
  return {
    productId,
    loading: true,
    swiperInstance: null,

    async fetchRecommendations() {
      try {
        const sectionId = 'cart-upsell-helper';
        const url = `${window.routes.product_recommendations_url}?section_id=${sectionId}&product_id=${this.productId}&intent=complementary`;

        const res = await fetch(url);
        const html = await res.text();

        if (html.includes('swiper-slide')) {
          // 1. Create a temporary virtual element to hold the response
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          // 2. Find all the slides inside that response
          const slides = tempDiv.querySelectorAll('.swiper-slide');

          // 3. Clear the wrapper and append ONLY the slides
          this.$refs.wrapper.innerHTML = '';
          slides.forEach((slide) => {
            this.$refs.wrapper.appendChild(slide);
          });

          this.loading = false;

          this.$nextTick(() => {
            this.buildSwiper();
          });
        } else {
          this.loading = false;
        }
      } catch (err) {
        console.error('Recommendation fetch error:', err);
        this.loading = false;
      }
    },

    buildSwiper() {
      // 1. Find the slider element specifically inside THIS component
      const sliderEl = this.$root.querySelector('.js-cart-upsell-slider__search-discovery');

      if (!sliderEl) {
        console.error('Swiper element not found within the component scope');
        return;
      }

      // 2. Destroy any existing instance to prevent "ghost" sliders
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }

      // 3. Initialize using the direct element reference instead of a class string
      this.swiperInstance = new Swiper(sliderEl, {
        slidesPerView: 3.5,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow: true,
        navigation: false,
        pagination: false,
      });
    },
  };
}
